import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import searchVacancyGroupAPI from '../../api/search-vacancy-group';
import { IFiltersState } from '../../components/VacanciesBlock/VacanciesBlock';
import { IGroup, IVacancy } from '../../utils/types/state-types';
import {
  receiveVacancyGroup,
  rejectVacancyGroup,
  requestSearchVacancy,
  requestVacancyGroup,
  reсeiveSearchVacancy,
} from '../actions/main-page';

interface ISearchVacanciesAction {
  type: string;
  payload: {
    searchValue: string;
    division: string;
    filterValues: IFiltersState;
    isFormSubmitted: boolean;
    setExpandedDropdownIds: React.Dispatch<React.SetStateAction<string[]>>;
  }
}

interface IGroupResponse {
  groups: IGroup[];
  vacancies: IVacancy[];
}

const searchVacancies = function* searchVacancies(action: ISearchVacanciesAction) {
  try {
    const response: IGroupResponse = yield call(
      searchVacancyGroupAPI,
      action.payload.searchValue,
      action.payload.division,
      action.payload.filterValues,
    );
    if (action.payload.isFormSubmitted) {
      yield put(receiveVacancyGroup({
        groups: response.groups,
        vacancies: response.vacancies,
        filterValues: action.payload.filterValues,
        [action.payload.searchValue
          || Object.values(action.payload.filterValues).some((item) => item.length !== 0)
          ? '' : 'defaultGroups']: response.groups,
      }));
      if (action.payload.searchValue) {
        action.payload.setExpandedDropdownIds(response.groups.map((item) => item.id));
      }
    } else {
      yield put(reсeiveSearchVacancy({
        vacancies: response.vacancies,
      }));
    }
  } catch (error) {
    yield put(rejectVacancyGroup({ error }));
  }
};

export default function* searchVacancyGroupWatcher() {
  yield takeLatest(requestVacancyGroup, searchVacancies);
}

export function* searchVacancyWatcher() {
  yield takeLatest(requestSearchVacancy, searchVacancies);
}
